import { checkGrantedAccess } from 'app/components/utils/utils';
import { AccessItem } from 'app/build-api';
import Subscriptions from './components/subscriptions';
import { NoAccess } from 'app/components/common/no-access/no-access';

export const SubscriptionContainer = () => {
  return checkGrantedAccess(AccessItem.TierManagement) ? <Subscriptions /> : <NoAccess />;
};
